module.exports = __webpack_public_path__ + "img/logoAniMemo192.e50d856b.png";